import React from "react";
import * as PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core";
import classNames from "classnames";
import SvgIcon from "@material-ui/core/SvgIcon";

const useStyles = makeStyles({
  container: props => ({
    width: props.width,
    height: props.height
  }),
  st0: {
    fill: "#cee0e9"
  },
  st1: {
    fill: "#cee0e9",
    stroke: "#5c9cb6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  },
  st2: {
    fill: "none",
    stroke: "#5c9cb6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  },
  st3: {
    fill: "#8db8cb",
    stroke: "#5c9cb6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }
});

const BrazilOutlineIcon = props => {
  const classes = useStyles(props);

  return (
    <SvgIcon
      viewBox="0 0 80 80"
      className={classNames(classes.container, props.className)}
    >
      <path
        className={classes.st0}
        d="M45.8,4.4l-2-4.4H0v46.4l7.3,5.5l-2.1,16L1.8,80h35.4l1.9-2.5c-2.4-1.9-5.5-4.4-6.5-5.3l6.8-5.3v-3.4h-1
	l1.1-2.5l-3.9-4h-2.7l-0.5-3.8l1.2-2.5l-0.8-4.8l-3.4-0.4l-0.8-4.7L19.8,38l-0.9-5.5l-6.7,2.9H8.1v-2.1L3.7,32l-2-3.8l3-4.7l4.8-1
	l0.9-6.8L10.2,11l4.7-0.8l1.3,2.5l6-3.5l-1.6-4c1.3,0,2.7,0,2.9,0C23.7,5.3,24,5.4,28,3.1l1,1.6l1.4,6.2l6.4-2.2l6.3-0.9L45.8,4.4z"
      />
      <path
        className={classes.st1}
        d="M37.2,80l1.9-2.5c-2.4-1.9-5.5-4.4-6.5-5.3l6.8-5.3v-3.4h-1l1.1-2.5l-3.9-4h-2.7l-0.5-3.8l1.2-2.5l-0.8-4.8
	l-3.4-0.4l-0.8-4.7L19.8,38l-0.9-5.5l-6.7,2.9H8.1v-2.1L3.7,32l-2-3.8l3-4.7l4.8-1l0.9-6.8L10.2,11l4.7-0.8l1.3,2.5l6-3.5l-1.6-4
	c1.3,0,2.7,0,2.9,0C23.7,5.3,24,5.4,28,3.1l1,1.6l1.4,6.2l6.4-2.2l6.3-0.9l2.7-3.4l-2-4.4"
      />
      <path className={classes.st2} d="M0,46.4l7.3,5.5l-2.1,16L1.8,80" />
      <path
        className={classes.st3}
        d="M75.4,29.4l-6.1,7.4l-0.6,7l-3.9,9.6c0,0-3,4-3.4,4.1s-4,0.8-4,0.8l-8.5,4.5c0,0-1.1,5.2-1.4,5.6
	c-0.2,0.2-5,5.4-8.5,9.1c-2.4-1.9-5.5-4.4-6.5-5.3l6.8-5.3v-3.4h-1l1.1-2.5l-3.9-4h-2.7l-0.5-3.8l1.2-2.5l-0.8-4.8l-3.4-0.4
	l-0.7-4.7L19.8,38l-0.9-5.5l-6.7,2.9H8.1v-2.1L3.7,32l-2-3.8l3-4.7l4.8-1l0.9-6.8L10.2,11l4.7-0.8l1.3,2.5l6-3.5l-1.6-4
	c1.3,0,2.7,0,2.9,0C23.7,5.3,24,5.4,28,3.1l1,1.6l1.4,6.2l6.4-2.2l6.3-0.9l2.5-3.4l2.7,3.9l-0.2,4.1l10.2,1.8l1.2,1.7l7.2-0.4l6.4,4
	h3.1c0,0,1,4,1,4.3C77.4,24.1,75.4,29.4,75.4,29.4z"
      />
    </SvgIcon>
  );
};

BrazilOutlineIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string
};

export default BrazilOutlineIcon;
